'use client';

// Ultima rete di sicurezza: sostituisce l'intero root layout, quindi deve
// definire da sé <html lang>, <title> e gli stili minimi.
export default function GlobalError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html lang="it">
      <head>
        <title>Errore | TDS Printing</title>
        <meta name="robots" content="noindex" />
      </head>
      <body style={{ margin: 0, fontFamily: 'system-ui, sans-serif', background: '#f8fafc', color: '#334155' }}>
        <main style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
          <div style={{ textAlign: 'center', maxWidth: 420 }}>
            <h1 style={{ fontSize: 24, marginBottom: 16 }}>Si è verificato un errore</h1>
            <p style={{ marginBottom: 24 }}>Non è stato possibile caricare il sito. Riprova tra qualche istante.</p>
            <button
              type="button"
              onClick={reset}
              style={{ background: '#3183d7', color: '#fff', border: 0, borderRadius: 8, padding: '12px 24px', fontWeight: 600, cursor: 'pointer' }}
            >
              Riprova
            </button>
          </div>
        </main>
      </body>
    </html>
  );
}
